
      import ToastMixin from 'uni-platform/components/app/popup/mixins/toast.js'
import PreviewImageMixin from 'uni-platform/components/app/popup/mixins/preview-image.js'
import ModalMixin from 'uni-platform/components/app/popup/mixins/modal.js'
      export default [
        ToastMixin,
PreviewImageMixin,
ModalMixin
      ]
      